import { render, staticRenderFns } from "./BackgroundPostContent.vue?vue&type=template&id=20e5d555&scoped=true&"
import script from "./BackgroundPostContent.vue?vue&type=script&lang=js&"
export * from "./BackgroundPostContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e5d555",
  null
  
)

export default component.exports